// extracted by mini-css-extract-plugin
export default {"container":"TenantPage_container__npum8","title":"TenantPage_title__NkIPP"};